module.exports = __webpack_public_path__ + "media/icon.99bd3b47.mp3";